import React from "react";
import { StoredValue } from "components/Icon.js";
import CmsContentRenderer from "components/data/CmsContentRenderer.js";
import CmsContentList from "components/data/CmsContentList.js";

import * as tables from "components/DataTable.module.css";

const cms = {
	balance: 'miscText.purchasehistory-table-product-balance',
};

const StoredCreditChip = ({	overrideClass = null }) =>
	<CmsContentList list={Object.values(cms)}>{() =>
		<>
			<StoredValue
				aria-hidden="true"
				data-qa="stored-value-icon"
				className={tables.splitPayIcon}
			/>

			<CmsContentRenderer.P
				className={overrideClass}
				contentKey={cms.balance}
				fallbackValue="Transit value"
			/>
		</>
	}</CmsContentList>;
export default StoredCreditChip;
